import React from 'react';

//Estilos
import '../App.css';
import { ArrowRightSquareFill } from 'react-bootstrap-icons';
import { ArrowRightCircleFill } from 'react-bootstrap-icons';

//media
import headerimg from '../media/headerimg.png';

//components

export class Headerappsa extends React.Component {
    render() {
        return (
            <div className='sshheaderappSa'>
                <div className='sshheaderContainer'>
                    <div className='sshheaderImg'>
                        
                    </div>
                    <div className='sshheaderDesc'>
                        <div className='sshheaderDescTit'>
                            <h1>Administracion de Sistemas</h1>
                        </div>
                        <div className='sshheaderDescItems'>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <ArrowRightCircleFill color='grey' />
                                        </td>
                                        <td>
                                        Gestiona usuarios   
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                        <ArrowRightCircleFill color='grey'/>
                                        </td>
                                        <td>
                                        Gestiona casinos y mas.        
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>   
                </div>
            </div>
        );
    }
}